/* globals FB */
// #region Imports
import { insertAsyncScript } from '@js/helpers';
import { purgeCookies } from './GatoSec/helpers';

// #endregion

function setFbDialogDisplay(display) {
  const fbDialog = document.querySelector('#fb-root .fb_dialog.fb_dialog_advanced');
  if (fbDialog) {
    fbDialog.style.display = display;
  }
}

export const fbChat = {
  load: (lazy) => {
    // TODO: load xfbml.customerchat.js only when needed if lazy loading
    if (!window.fbAsyncInit) {
      console.warn('facebook chat');
      window.fbAsyncInit = () => {
        FB.init({
          xfbml: !lazy,
          version: 'v18.0',
        });
      };
      insertAsyncScript('facebook-jssdk', 'https://connect.facebook.net/fr_FR/sdk/xfbml.customerchat.js');
    } else if (window.FB && window.FB.CustomerChat) {
      setFbDialogDisplay('inline');
    }
  },

  deleteCookies: () => {
    if (window.FB && window.FB.CustomerChat) {
      setFbDialogDisplay('none');
    }
    purgeCookies([('act', 'c_user', 'datr', 'dpr', 'presence', 'sb', 'wd', 'xs', '/tr')]);
  },
};
